import { CalendarDays } from "lucide-react";
import { StatusBadge } from "./StatusBadge";
import { KIND_LABEL, dayLabel, topicTitle } from "./socialMeta";

export const UpcomingStrip = ({ posts, today, selected, onSelect }) => (
  <section data-testid="social-calendar" className="bg-white border border-[#ECE7DE] rounded-2xl p-4 sm:p-5">
    <h3 className="flex items-center gap-2 text-sm font-bold text-[#1A1A1A] mb-3">
      <CalendarDays className="w-4 h-4 text-[#F26419]" /> Calendrier des posts à venir
    </h3>
    <div className="grid grid-flow-col auto-cols-[minmax(160px,1fr)] gap-2.5 overflow-x-auto pb-2">
      {posts.map((p) => {
        const active = selected === p.date;
        return (
          <button key={p.date} data-testid={`social-day-${p.date}`} onClick={() => onSelect(p.date)}
            className={`text-left rounded-xl border p-3 transition-colors duration-200 ${active ? "border-[#F26419] bg-[#FEF1E7]" : "border-[#ECE7DE] hover:bg-[#F7F4EF]"}`}>
            <div className="text-xs font-bold uppercase tracking-wide text-[#75807A] whitespace-nowrap">{p.date === today ? "Aujourd'hui" : dayLabel(p.date)}</div>
            <div className="flex items-center gap-1.5 mt-2 text-[11px] font-semibold text-[#059669]">
              {KIND_LABEL[p.topic?.kind]}
              {p.override && <span data-testid={`social-day-manual-${p.date}`} className="px-1.5 rounded bg-[#FEF1E7] text-[10px] font-bold text-[#D8531E]">MANUEL</span>}
            </div>
            <div className="text-sm font-semibold text-[#1A1A1A] line-clamp-2 min-h-[2.5rem]">{topicTitle(p.topic)}</div>
            <div className="mt-2"><StatusBadge status={p.status} testId={`social-day-status-${p.date}`} /></div>
          </button>
        );
      })}
    </div>
  </section>
);
